import type { ChatbotSupportedCountry } from "../types/chatbot-supported-country";

import { createCountryAllowlist } from "../capabilities/create-country-allowlist";

const CHATBOT_SUPPORTED_COUNTRIES = [
  "usa",
  "can",
] as const satisfies readonly ChatbotSupportedCountry[];

const chatbotCountryAllowlist = createCountryAllowlist(
  CHATBOT_SUPPORTED_COUNTRIES,
);

export { CHATBOT_SUPPORTED_COUNTRIES, chatbotCountryAllowlist };
